import axios from "axios";
import jsonpAdapter from "axios-jsonp";
import { httpAPI } from "@/api/httpAPI";
import store from '@/store';
import i18n from '@/i18n';

const signClient = axios.create({
    baseURL: 'http://127.0.0.1:15000/SignService/'
});
const alias = 'Avrora3';
const legacySignRequest = async function(params) {
    try
    {
        const t = encodeURIComponent(params.token);

        let response = await axios({
            url: `http://127.0.0.1:15000/sign?doc_id=${params.id}&host=${params.endpoint}&token=${t}&alias=${alias}`,
            method: 'GET',
            withCredentials: true,
            adapter: jsonpAdapter,
        });

        return { success: true, response };
    }
    catch (ex)
    {
        return { success: false, error: ex };
    }
};
const tumarProfilesRequest = function(password) {
    return signClient({
        url: `TumarProfiles`,
        method: "POST",
        data: { password },
        withCredentials: true,
    });
};
const tumarDistinguishedNamesRequest = function(grant, profile) {
    return signClient({
        url: `TumarProfileInfo`,
        method: "POST",
        data: { grant, profile },
        withCredentials: true,
    });
};
const tumarSignDataRequest = function(grant, profile, dn, data) {
    return signClient({
        url: `SignData`,
        method: "POST",
        data: { grant, profile, dn, data },
        withCredentials: true,
    });
};
const tumarCertificateInfoRequest = function(grant, profile, dn) {
    return signClient({
        url: `CertificateInfo`,
        method: "POST",
        data: { grant, profile, dn },
        withCredentials: true,
    });
};
const handshakeRequest = function(password) {
    return signClient({
        url: `Handshake`,
        method: "POST",
        data: { password },
        withCredentials: true,
    });
};
const signDocumentRequest = function(grant, profile, id, signType, host, token) {
    return signClient({
        url: `SignDocument`,
        method: "POST",
        data: { grant, profile, id, signType, host, token },
        withCredentials: true
    });
};
const signNotifyRejectRequest = function(grant, profile, host, token, reason) {
    return signClient({
        url: `SignNotifyReject`,
        method: "POST",
        data: { grant, profile, host, token, reason},
        withCredentials: true
    });
};
const signNotifyRegisterRequest = function(grant, profile, host, token, number) {
    return signClient({
        url: `SignNotifyRegister`,
        method: "POST",
        data: { grant, profile, host, token, number},
        withCredentials: true
    });
};
const signDocument = async function (type, dispatch, params) {
    try
    {
        dispatch('setOverlayVisible', { visible: false }, { root: true });
        let password = process?.env?.VUE_APP_TUMAR_PROMPT_PASSWORD === "true"
            ? await dispatch('promptPassword')
            : await dispatch('getSHA256Secret');

        if (typeof type === "string" && type == "UCGO") {

            dispatch('setOverlayVisible', { visible: true }, { root: true });
            let initial = await tumarProfilesRequest(password);
            dispatch('setOverlayVisible', { visible: false }, { root: true });

            if (initial.data?.Result !== 'OK')
                return { success: false, message: initial.data.Message };

            let initialObject = JSON.parse(initial.data.Data.Object);
            let profile = await dispatch('promptProfile', initialObject.Profiles);

            dispatch('setOverlayVisible', { visible: true }, { root: true });
            let signResult = await signDocumentRequest(initialObject.Grant, profile, params.id, params.documentType, params.endpoint, params.token);
            dispatch('setOverlayVisible', { visible: false }, { root: true });

            if (signResult.data.Result !== 'OK')
                return { success: false, message: signResult.data.Message };

            return { success: true, response: signResult, message: signResult.data.Message };

        }
    }
    catch (ex)
    {
        return { success: false, message: ex.message };
    }
    finally
    {
        dispatch('setOverlayVisible', { visible: false }, { root: true });
    }
};
const NIC_onopen = function (event) {
    console.log("[NIC_onopen]: Connection opened", event);
};
const NIC_onclose = function (event) {
    if (event.wasClean)
		console.log('[NIC_onclose]: Connection has been closed');
    else
		console.log('[NIC_onclose]: Connection error');

	console.log(`[NIC_onclose]: Code: ${event.code} Reason: ${event.reason}`);
};
const NIC_onmessage = function (event) {
    var result = JSON.parse(event.data); 

	if (result != null) {
		var rw = {
			code: result['code'],
			message: result['message'],
			responseObject: result['responseObject'],
            signInfoObject: result['signInfoObject'],
			getResult: function () {
				return this.result;
			},
			getMessage: function () {
				return this.message;
			},
			getResponseObject: function () {
				return this.responseObject;
			},
			getCode: function () {
				return this.code;
			}
		};

		if (store.getters['signing/getNICCallback'] != null) {
			store.getters['signing/getNICCallback'](rw);
		}
	}
};
const NIC_createCAdESFromBase64Call = function (connection, storageName, keyType, base64ToSign, attach) {
    var createCAdESFromBase64 = {
		"module": "kz.gov.pki.knca.commonUtils",
		"method": "createCAdESFromBase64",
		"args": [storageName, keyType, base64ToSign, attach]
	};
	connection.send(JSON.stringify(createCAdESFromBase64));
    store.commit('signing/SET_NIC_CALLBACK', NIC_createCAdESFromBase64Back);
};
const NIC_createCAdESFromBase64Back = function(result) {
	if (result['code'] === "500") {
        store.state.signing.NIC_reject({ message: "Взаимодествие_с_NCALayer_прервано" })
	}
    else if (result['code'] === "200") {
        let response = result['responseObject'];

		if (response != null && typeof response === 'string' && response.length > 200)
            store.state.signing.NIC_resolve({ sign: response });
        else
            store.state.signing.NIC_reject({ message: "Не_удалось_получить_данные_подписи" });
	}
};
const NIC_getActiveTokensCall = function(connection) {
    store.commit('signing/SET_PROMPT_PROFILE_LOADING', true);    
    var getActiveTokens = {
        "module": "kz.gov.pki.knca.commonUtils",
        "method": "getActiveTokens"
    };    
    connection.send(JSON.stringify(getActiveTokens));
    store.commit('signing/SET_NIC_CALLBACK', NIC_getActiveTokensBack);
};
const NIC_getActiveTokensBack = function(result) {    
    let listOfTokens = ['PKCS12'];
    
    if (result['code'] === "200")
		listOfTokens = listOfTokens.concat(result['responseObject']);
    else
        alert(result['message']);

    store.commit('signing/SET_PROFILES', listOfTokens);
    store.commit('signing/SET_PROMPT_PROFILE_LOADING', false);
};
const NIC_getKeyInfoCall = function (connection, storageName) {
    var getKeyInfo = {
		"module": "kz.gov.pki.knca.commonUtils",
		"method": "getKeyInfo",
		"args": [storageName]
	};
	connection.send(JSON.stringify(getKeyInfo));
    store.commit('signing/SET_NIC_CALLBACK', NIC_getKeyInfoBack);
};
const NIC_getKeyInfoBack = function (result) {
    if (result['code'] === "500") {
        store.state.signing.NIC_reject({ message: "Взаимодествие_с_NCALayer_прервано" })
	}
    else if (result['code'] === "200") {
        let response = result['responseObject'];

		if (response)
            store.state.signing.NIC_resolve({ keyInfo: response });
        else
            store.state.signing.NIC_reject({ message: "Не_удалось_получить_данные_подписи" });
	}
};
const NIC_getKeyInfoArtaSynergyCall = function (connection, storageName) {
    var getKeyInfo = {
		"module": "kz.arta.synergy.signmodule",
		"method": "getKeyInfo",
		"args": [storageName]
	};
    connection.send(JSON.stringify(getKeyInfo));
    store.commit('signing/SET_NIC_CALLBACK', NIC_getKeyInfoArtaSynergyBack);
};
const NIC_getKeyInfoArtaSynergyBack = function (result) {
    if (result['code'] === "500")
        store.state.signing.NIC_reject({ message: "Взаимодествие_с_NCALayer_прервано" });

    if (result['code'] !== "200")
        store.state.signing.NIC_reject({ message: "Модуль_Arta_Synergy_не_установлен" });
    
    result['signInfoObject']
        ? store.state.signing.NIC_resolve({ keyInfo: result['signInfoObject'] })
        : store.state.signing.NIC_reject({ message: "Не_удалось_получить_данные_подписи" });
};
const NIC_signArtaSynergyCall = function (connection, digest) {
    var getKeyInfo = {
		"module": "kz.arta.synergy.signmodule",
		"method": "signDocument",
		"args": [ digest, "SIGN", "R09TVEtOQ0FfYTFmY2ZiZTEwMWUzYzA0YTU1MGJhNDkwMGVhZTFhNDgyMWNiMjM0Mg=="]
	};
    connection.send(JSON.stringify(getKeyInfo));
    store.commit('signing/SET_NIC_CALLBACK', NIC_signArtaSynergyBack);
};
const NIC_signArtaSynergyBack = function (result) {
    if (result['code'] === "500")
        store.state.signing.NIC_reject({ message: "Взаимодествие_с_NCALayer_прервано" });

    if (result['code'] !== "200")
        store.state.signing.NIC_reject({ message: "Модуль_Arta_Synergy_не_установлен" });

    let responseObject = result['responseObject'];

    responseObject && typeof responseObject === 'object' && Object.prototype.hasOwnProperty.call(responseObject, 'esedoSign')
        ? store.state.signing.NIC_resolve({ keyInfo: result['responseObject'] })
        : store.state.signing.NIC_reject({ message: "Не_удалось_получить_данные_подписи" });
};

const UCGO_DEFAULT_PROFILE = "profile://ESEDO004";

const delay = (delayInms) => {
    return new Promise(resolve => setTimeout(resolve, delayInms));
};

const signing =
{
    namespaced: true,
    state: {
        promptPasswordVisible: false,
        promptPasswordResolve: null,
        promptPasswordReject: null,
        password: null,

        promptProfileVisible: false,
        promptProfileLoading: false,
        promptProfileResolve: null,
        promptProfileReject: null,
        profile: null,
        profiles: [],

        meta: null,

        NIC_WebSocketConnection: null,
        NIC_callback: null,
        NIC_resolve: null,
        NIC_reject: null,
    },
    mutations: {
        SET_META(state, payload) {
            state.meta = payload;
        },
        SET_PROMPT_PASSWORD_VISIBLE(state, payload) {
            state.promptPasswordVisible = payload;
        },
        SET_PROMPT_PASSWORD_RESOLVE(state, payload) {
            state.promptPasswordResolve = payload;
        },
        SET_PROMPT_PASSWORD_REJECT(state, payload) {
            state.promptPasswordReject = payload;
        },
        SET_PASSWORD(state, payload) {
            state.password = payload;
        },
        SET_PROMPT_PROFILE_VISIBLE(state, payload) {
            state.promptProfileVisible = payload;
        },
        SET_PROMPT_PROFILE_LOADING(state, payload) {
            state.promptProfileLoading = payload;
        },
        SET_PROMPT_PROFILE_RESOLVE(state, payload) {
            state.promptProfileResolve = payload;
        },
        SET_PROMPT_PROFILE_REJECT(state, payload) {
            state.promptProfileReject = payload;
        },
        SET_PROFILE(state, payload) {
            state.profile = payload;
        },
        SET_PROFILES(state, payload) {
            state.profiles = payload;
        },
        SET_NIC_WEB_SOCKET_CONNECTION(state, payload) {
            state.NIC_WebSocketConnection = new WebSocket(payload);            
            state.NIC_WebSocketConnection.onopen = NIC_onopen;
            state.NIC_WebSocketConnection.onclose = NIC_onclose;
            state.NIC_WebSocketConnection.onmessage = NIC_onmessage;
        },
        SET_NIC_CALLBACK(state, payload) {
            state.NIC_callback = payload;
        },
        SET_NIC_RESOLVE(state, payload) {
            state.NIC_resolve = payload;
        },
        SET_NIC_REJECT(state, payload) {
            state.NIC_reject = payload;
        }
    },
    actions: {
        async signDocumentUCGO({ state, commit, dispatch }, { id, documentType } ) {

            dispatch('setOverlayVisible', { visible: true }, { root: true });

            //если данные для начала процесса подписания еще не получены
            if (!state.meta) {

                //пытаемся их получить
                let signingMetaData = await httpAPI({
                    url: '/api/references/signmetadata',
                    method: 'GET'
                });

                if (signingMetaData)
                    commit('SET_META', signingMetaData.data.payload);
                else
                    return { success: false, message: null };
            }

            //проверяем, нужно ли отправлять запрос на старую версию ариадны
            if (state.meta.checkLegacy === true)
            {
                
                let legacySign = await legacySignRequest({ id, endpoint: state.meta.endpoint, token: state.meta.token });

                if (legacySign.success)
                {
                    switch (legacySign.response.data.Result)
                    {
                        //кейс, если сервер уже обновлен для работы со службой, но у клиента еще нет новой службы, подписано успешно
                        case "OK":
                        {
                            dispatch('setOverlayVisible', { visible: false }, { root: true });
                            return { success: true, message: legacySign.response.data.Message };
                        }
                        //кейс, если сервер уже обновлен для работы со службой, и у клиента уже есть новая служба
                        case "DEPRECATED":
                        {
                            return await signDocument('UCGO', dispatch, { id, documentType, endpoint: state.meta.endpoint, token: state.meta.token });
                        }
                        //кейс, если сервер уже обновлен для работы со службой, но у клиента еще нет новой службы, ошибка в процессе подписания
                        case "ERROR":
                        {
                            dispatch('setOverlayVisible', { visible: false }, { root: true });
                            return { success: false, message: legacySign.response.data.Message };
                        }

                        default:
                            break;
                    }
                }
                else
                {
                    dispatch('setOverlayVisible', { visible: false }, { root: true });
                    return { success: false, message: legacySign.error.message };
                }
            }
            else
            {
                return await signDocument('UCGO', dispatch, { id, documentType, endpoint: state.meta.endpoint, token: state.meta.token });
            }
        },
        async signSimple({ dispatch, rootGetters }, id) {
            dispatch('setOverlayVisible', { visible: true }, { root: true });

            let response = await httpAPI({
                url: `/api/actions/signsimple/${id}`,
                method: 'POST',
                headers: { 'isCommon': rootGetters['actionsource/isDataSourceCommon']}
            });

            dispatch('setOverlayVisible', { visible: false }, { root: true });

            if (!response)
                return { success: false };

            return { success: true, message: response.data.payload.Message };
        },
        async signNotification({ dispatch, commit, state, rootGetters }, { notificationType, dataToSign, regDate }) {
            dispatch('setOverlayVisible', { visible: true }, { root: true });

            //если данные для начала процесса подписания еще не получены
            if (!state.meta) {

                //пытаемся их получить
                let signingMetaData = await httpAPI({
                    url: '/api/references/signmetadata',
                    method: 'GET'
                });

                if (signingMetaData)
                    commit('SET_META', signingMetaData.data.payload);
                else
                    return { success: false, message: null };
            }

            try
            {
                //получаем тип подписи
                let serverSignType = await dispatch('signing/getUsedSignType', null, { root: true });
                dispatch('setOverlayVisible', { visible: false }, { root: true });

                let signResult = null;

                switch (serverSignType) {
                    //УЦГО
                    case 1:
                        {
                            //запрашиваем пароль
                            let password = process?.env?.VUE_APP_TUMAR_PROMPT_PASSWORD === "true"
                                ? await dispatch('promptPassword')
                                : await dispatch('getSHA256Secret');

                            //получаем данные профайлов и ключ доступа к сервису
                            dispatch('setOverlayVisible', { visible: true }, { root: true });
                            let initial = await tumarProfilesRequest(password);
                            dispatch('setOverlayVisible', { visible: false }, { root: true });

                            if (initial.data.Result !== 'OK')
                                return { success: false, message: initial.data.Message };

                            let initialObject = JSON.parse(initial.data.Data.Object);
                            //запрашиваем профайл
                            let profile = await dispatch('promptProfile', initialObject.Profiles);
                            dispatch('setOverlayVisible', { visible: true }, { root: true });

                            switch (notificationType) {
                                case 'REJECT':
                                    signResult = await signNotifyRejectRequest(initialObject.Grant, profile, state.meta.endpoint, state.meta.token, dataToSign);
                                    break;

                                case 'REGISTER':
                                    signResult = await signNotifyRegisterRequest(initialObject.Grant, profile, state.meta.endpoint, state.meta.token, dataToSign);
                                    break;

                                default:
                                    break;
                            }

                            dispatch('setOverlayVisible', { visible: false }, { root: true });

                            if (signResult.data.Result !== 'OK')
                                return { success: false, message: signResult.data.Message };

                            return { success: true, message: signResult.data.Message };
                        }
                    //НУЦ
                    case 2:
                        {
                            let { keyInfo } = await dispatch('signing/getKeyInfoFromArtaSynergy', null, { root: true });

                            let notify = null;

                            switch (notificationType) {
                                case 'REJECT':
                                    notify =
                                    {
                                        NotifyType: notificationType,
                                        DocumentID: rootGetters['actionsource/getDataSourceIdentifier'],
                                        RejectReason: dataToSign
                                    };
                                    break;

                                case 'REGISTER':
                                    notify =
                                    {
                                        NotifyType: notificationType,
                                        DocumentID: rootGetters['actionsource/getDataSourceIdentifier'],
                                        RegNumber: dataToSign,
                                        RegDate: regDate
                                    };
                                    break;

                                default:
                                    return { success: false, message: 'Тип уведомления не предназначен для подписания' };
                            }

                            dispatch('setOverlayVisible', { visible: true }, { root: true });

                            let signInfoResponse = await httpAPI({
                                url: `api/signing/notify-info`,
                                method: 'POST',
                                headers: { 'isCommon': rootGetters['actionsource/isDataSourceCommon'] },
                                data: { Pem: keyInfo.pem, Content: JSON.stringify(notify) },
                            });

                            if (!signInfoResponse) {
                                dispatch('setOverlayVisible', { visible: false }, { root: true });
                                return;
                            }

                            let signResult = await dispatch('signing/signDocumentNICArtaSynergy', { data: { digest: signInfoResponse.data.payload.Data.Object.Hash, fileNames: ['none'] } }, { root: true });

                            dispatch('setOverlayVisible', { visible: false }, { root: true });

                            return { success: true, message: signResult.keyInfo.esedoSign };
                        }
                    default:
                        {
                            dispatch('setOverlayVisible', { visible: false }, { root: true });
                            return { success: false, message: 'Тип подписи не определен' };
                        }
                }                
            }
            catch (ex)
            {
                return { success: false, message: ex.message };
            }
            finally
            {
                dispatch('setOverlayVisible', { visible: false }, { root: true });
            }
        },
        async promptPassword({ commit }) {
            commit('SET_PASSWORD', null);
            commit('SET_PROMPT_PASSWORD_VISIBLE', true);

            return new Promise((resolve, reject) => {
                commit('SET_PROMPT_PASSWORD_RESOLVE', resolve);
                commit('SET_PROMPT_PASSWORD_REJECT', reject);
            });
        },
        async passwordOk({ commit, state }) {
            commit('SET_PROMPT_PASSWORD_VISIBLE', false);
            state.promptPasswordResolve(state.password);
        },
        async passwordCancel({ commit, state }) {
            commit('SET_PROMPT_PASSWORD_VISIBLE', false);
            state.promptPasswordReject({ message: i18n.t("Ввод_пароля_отменен") });
        },
        async promptProfile({ commit, rootGetters }, profiles) {
            let userProfile = new String(rootGetters['auth/getUserInfo']?.tumarProfile);
            let upperCaseProfiles = Array.from(profiles).map(x => new String(x).toUpperCase());

            if (!!userProfile && upperCaseProfiles.includes(userProfile.toUpperCase()))
                return Promise.resolve(userProfile);

            if (profiles.includes(UCGO_DEFAULT_PROFILE)) {
                commit('SET_PROFILE', UCGO_DEFAULT_PROFILE);
            }
            else {
                commit('SET_PROFILE', null);
            }

            commit('SET_PROFILES', profiles);
            commit('SET_PROMPT_PROFILE_VISIBLE', true);

            return new Promise((resolve, reject) => {
                commit('SET_PROMPT_PROFILE_RESOLVE', resolve);
                commit('SET_PROMPT_PROFILE_REJECT', reject);
            });
        },
        async profileOk({ commit, state }) {
            commit('SET_PROMPT_PROFILE_VISIBLE', false);
            state.promptProfileResolve(state.profile);
        },
        async profileCancel({ commit, state }) {
            commit('SET_PROMPT_PROFILE_VISIBLE', false);
            state.promptProfileReject({ message: "Выбор_профайла_отменен" });
        },
        async openNICConnection({ commit, getters }) {
            if (!getters.isNICConnectionValid) {
                commit('SET_NIC_WEB_SOCKET_CONNECTION', 'wss://127.0.0.1:13579/');
                await delay(1000);
            }
        },
        async signDocumentNIC({ state, commit, dispatch }, { data }) {
            return new Promise((resolve, reject) => {
                (async () => {
                    commit('SET_NIC_RESOLVE', resolve);
                    commit('SET_NIC_REJECT', reject);
                    
                    await dispatch('signing/openNICConnection', null, { root: true });
                    
                    if (state.NIC_WebSocketConnection == null || state.NIC_WebSocketConnection.readyState != 1) {
                        reject({ message: "Нет соединения с NCALayer!" })
                        return;
                    }

                    if (data == null || typeof data !== 'string' || data.length < 200) {
                        reject({ message: 'Недостаточно_данных_для_подписания_договора' })
                        return;
                    }
                    
                    try
                    {
                        NIC_getActiveTokensCall(state.NIC_WebSocketConnection);
                        let profile = await store.dispatch('signing/promptProfile', []);
                        NIC_createCAdESFromBase64Call(state.NIC_WebSocketConnection, profile, "SIGNATURE", data, false);
                    }
                    catch(ex)
                    {
                        reject({ message: ex.message });
                        return;
                    }
                })();
            });
        },
        async getNICProfiles({ state, commit, dispatch }) {
            return new Promise((resolve, reject) => {
                (async () => {
                    commit('SET_NIC_RESOLVE', resolve);
                    commit('SET_NIC_REJECT', reject);

                    await dispatch('signing/openNICConnection', null, { root: true });

                    if (state.NIC_WebSocketConnection == null || state.NIC_WebSocketConnection.readyState != 1) {
                        reject({ message: "Нет соединения с NCALayer!" })
                        return;
                    }

                    try
                    {
                        NIC_getActiveTokensCall(state.NIC_WebSocketConnection);
                        let profile = await store.dispatch('signing/promptProfile', []);
                        NIC_getKeyInfoCall(state.NIC_WebSocketConnection, profile);
                    }
                    catch(ex)
                    {
                        reject({ message: ex.message });
                        return;
                    }

                })();
            });
        },
        async signAuthNIC({ state, commit, dispatch }, { data }) {
            return new Promise((resolve, reject) => {
                (async () => {
                    commit('SET_NIC_RESOLVE', resolve);
                    commit('SET_NIC_REJECT', reject);
                    
                    await dispatch('signing/openNICConnection', null, { root: true });

                    if (state.NIC_WebSocketConnection == null || state.NIC_WebSocketConnection.readyState != 1) {
                        reject({ message: "Нет соединения с NCALayer!" })
                        return;
                    }

                    if (data == null || typeof data !== 'string') {
                        reject({ message: 'Недостаточно_данных_для_подписания' })
                        return;
                    }
                    
                    try
                    {
                        NIC_getActiveTokensCall(state.NIC_WebSocketConnection);
                        let profile = await store.dispatch('signing/promptProfile', []);
                        NIC_createCAdESFromBase64Call(state.NIC_WebSocketConnection, profile, "AUTHENTICATION", data, true);
                    }
                    catch(ex)
                    {
                        reject({ message: ex.message });
                        return;
                    }
                })();
            });
        },
        async fetchTumarHandshake(_, { password }) {
            try
            {
                var req =  await handshakeRequest(password);

                if (req.data?.Result !== 'OK')
                    return { success: false, message: req.data.Message };

                return JSON.parse(req.data.Data.Object);
            }
            catch (ex)
            {
                return { success: false, message: ex.message };
            }
        },
        async fetchTumarProfiles(_, { password }) {
            try
            {
                var req =  await tumarProfilesRequest(password);

                if (req.data?.Result !== 'OK')
                    return { success: false, message: req.data.Message };

                return JSON.parse(req.data.Data.Object);
            }
            catch (ex)
            {
                return { success: false, message: ex.message };
            }
        },
        async fetchTumarProfileDistinguishedNames(_, { grant, profile }) {
            try
            {
                var req =  await tumarDistinguishedNamesRequest(grant, profile);

                if (req.data?.Result !== 'OK')
                    return { success: false, message: req.data.Message };

                return JSON.parse(req.data.Data.Object);
            }
            catch (ex)
            {
                return { success: false, message: ex.message };
            }
        },
        async fetchTumarSignData(_, { grant, profile, dn, data }) {
            try
            {
                var req =  await tumarSignDataRequest(grant, profile, dn, data);

                if (req.data?.Result !== 'OK')
                    return { success: false, message: req.data.Message };

                return JSON.parse(req.data.Data.Object);
            }
            catch (ex)
            {
                return { success: false, message: ex.message };
            }
        },
        async fetchTumarCertificateInfoRequest(_, { grant, profile, dn }) {
            try
            {
                var req =  await tumarCertificateInfoRequest(grant, profile, dn);

                if (req.data?.Result !== 'OK')
                    return { success: false, message: req.data.Message };

                return JSON.parse(req.data.Data.Object);
            }
            catch (ex)
            {
                return { success: false, message: ex.message };
            }
        },
        getSHA256Secret() {
            return "47e5a75df97fc7cf4089eb93363a69a214f747b9a5d13426033635ec9e34b05b";
        },
        async getUsedSignType() {
            let response = await httpAPI({
                url: '/api/ems/getsecuritysettingvalue?name=USED_SIGN_TYPE',
                method: 'GET'
            });

            if (response && response.data.success)
                return response.data.payload.data.object;

            return 1; //UCGO
        },
        async getKeyInfoFromArtaSynergy({ state, commit, dispatch }) {
            return new Promise((resolve, reject) => {
                (async () => {
                    commit('SET_NIC_RESOLVE', resolve);
                    commit('SET_NIC_REJECT', reject);

                    await dispatch('signing/openNICConnection', null, { root: true });

                    if (state.NIC_WebSocketConnection == null || state.NIC_WebSocketConnection.readyState != 1) {
                        reject({ message: "Нет соединения с NCALayer!" })
                        return;
                    }

                    try
                    {
                        NIC_getActiveTokensCall(state.NIC_WebSocketConnection);
                        let profile = await store.dispatch('signing/promptProfile', []);
                        NIC_getKeyInfoArtaSynergyCall(state.NIC_WebSocketConnection, profile);
                    }
                    catch(ex)
                    {
                        reject({ message: ex.message });
                        return;
                    }
                })();
            });
        },
        async signDocumentNICArtaSynergy({ state, commit, dispatch }, { data }) {
            return new Promise((resolve, reject) => {
                (async () => {
                    commit('SET_NIC_RESOLVE', resolve);
                    commit('SET_NIC_REJECT', reject);

                    await dispatch('signing/openNICConnection', null, { root: true });

                    if (state.NIC_WebSocketConnection == null || state.NIC_WebSocketConnection.readyState != 1) {
                        reject({ message: "Нет соединения с NCALayer!" })
                        return;
                    }

                    try
                    {
                        NIC_signArtaSynergyCall(state.NIC_WebSocketConnection, JSON.stringify(data));
                    }
                    catch(ex)
                    {
                        reject({ message: ex.message });
                        return;
                    }
                })();
            });
        }
    },
    getters: {
        isPromptPasswordVisible: (s) => s.promptPasswordVisible,
        isPromptProfileVisible: (s) => s.promptProfileVisible,
        getPassword: (s) => s.password,
        getProfile: (s) => s.profile,
        isPromptProfileLoading: (s) => s.promptProfileLoading,
        getProfiles: (s) => s.profiles.map(x => ({ id: x, Value: x.replace("profile://", "") })),
        getNICCallback: (s) => s.NIC_callback,
        isNICConnectionValid: (s) => s.NIC_WebSocketConnection != null && s.NIC_WebSocketConnection.readyState == 1,
    }
}

export default signing;